import {
    apiRequest,
    employeeWFHDetail,
    employeeWFHReportApproval
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeWFHDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", employeeWFHReportApproval, {
            body: query
        }, true)
    }
}

export default DetailRepository